module.exports = __webpack_public_path__ + "static/media/Icon-SendMoney.04ef9087.png";